import cn from 'classnames';
import { SliderProps } from 'rc-slider';
import * as React from 'react';

import FontAwesome from 'components/FontAwesome';
import IconButton from 'components/IconButton/IconButton';
import WrappedSlider from 'components/WrappedSlider';

const ZOOM_OPTIONS: Pick<SliderProps, 'step' | 'min' | 'max'> = {
  max: 5,
  min: 0,
  step: 0.01,
};

export type OnZoomChange = (params: { zoom: number }) => void;

interface IProps extends Pick<SliderProps, 'step' | 'min' | 'max'> {
  className?: string;
  onZoomChange: OnZoomChange;
  zoom: number;
  containerRef: React.ForwardedRef<HTMLDivElement>;
}

class VideoZoomSliderComponent extends React.Component<IProps> {
  private handleZoomChange = (zoom: number) => {
    this.props.onZoomChange({ zoom });
  };

  public render() {
    const {
      className,
      containerRef,
      zoom,
      onZoomChange,
      step,
      min,
      max,
    } = this.props;

    return (
      <div className={cn('video-zoom-slider', className)} ref={containerRef}>
        <IconButton
          onButtonClick={onZoomChange}
          onLongButtonClick={onZoomChange}
          params={{ zoom: zoom + ZOOM_OPTIONS.step }}
        >
          <FontAwesome icon="search-plus" className="video-zoom-slider__icon" />
        </IconButton>
        <WrappedSlider
          step={step ?? ZOOM_OPTIONS.step}
          min={min ?? ZOOM_OPTIONS.min}
          max={max ?? ZOOM_OPTIONS.max}
          vertical
          value={zoom}
          onChange={this.handleZoomChange}
        />
        <IconButton
          onButtonClick={onZoomChange}
          onLongButtonClick={onZoomChange}
          params={{ zoom: zoom - ZOOM_OPTIONS.step }}
        >
          <FontAwesome
            icon="search-minus"
            className="video-zoom-slider__icon"
          />
        </IconButton>
      </div>
    );
  }
}

const VideoZoomSlider = React.forwardRef<
  HTMLDivElement,
  Omit<IProps, 'containerRef'>
>((props, ref) => <VideoZoomSliderComponent {...props} containerRef={ref} />);

export default VideoZoomSlider;
